import Vue from 'vue'
import { getHomeHostUrl } from '@/assets/js/CommonUtils'

export default {
  data () {
    return {
      homeHostUrl: getHomeHostUrl(),
      trans: '',
      maskText: '',
      maskCount: 0,
      appUrl: 'javascript: void(0);'
    }
  },
  computed: {
    showLoading () {
      return this.$store.state.showLoading
    }
  },
  created () {
    const vm = this
    setTimeout(function () {
      vm.trans = 'active'
    }, 100)
  },
  activated () {
    const vm = this
    setTimeout(function () {
      vm.trans = 'active'
    }, 100)
  },
  deactivated () {
    this.trans = ''
  },
  methods: {
    ajax (options) {
      const vm = this
      const URL = options.url
      const onSuccess = function (response) {
        if (options.mask) {
          vm.unmask()
        }
        options.success && options.success(response)
      }
      const onError = function (response) {
        if (options.mask) {
          vm.unmask()
        }
        const userAgent = window.navigator.userAgent
        const isAndroid = userAgent.indexOf('Android') > -1
        const isIphone = userAgent.indexOf('iPhone') > -1
        // 401 403
        if ((response.status === 401 || response.status === 403) && !(isIphone || isAndroid)) {
          location.href = location.origin + '?os_destination=' + encodeURIComponent(location.href)
          return false
        }
        if (options.error) {
          options.error(response)
        } else if (response.status === 0) {
          return false
        } else {
          const message = response.data.message || '服务器发生了一个小错误，请联系下客服吧~(code: ' + response.status + ')'
          vm.$alert && vm.$alert(message, '提示')
        }
      }
      const params = options.data
      const contentType = options.contentType
      let isEmulateJSON = true
      if (contentType && contentType !== 'application/x-www-form-urlencoded') {
        isEmulateJSON = false
      }
      if (options.mask) {
        this.mask(options.maskText || '')
      }
      if (options.type === 'POST') {
        Vue.http.post(URL, params, { emulateJSON: isEmulateJSON }).then(onSuccess, onError)
      } else if (options.type === 'PUT') {
        Vue.http.put(URL, params, { emulateJSON: isEmulateJSON }).then(onSuccess, onError)
      } else {
        Vue.http.get(URL, { params: params }).then(onSuccess, onError)
      }
    },
    mask (text) {
      this.maskText = text
      if (this.maskCount === 0) {
        this.$store.state.showLoading = true
      }
      this.maskCount++
    },
    unmask () {
      this.maskCount--
      if (this.maskCount === 0) {
        this.$store.state.showLoading = false
      }
      if (this.maskCount < 0) {
        this.showLoading = 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/BaseVueOptions.js